import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Grade } from '../../models/application/grade.interface';
import { Observable } from 'rxjs';
import { HttpParamObject } from '../../utility/http-utility/http-param-object.interface';
import { HttpUtilityService } from '../../utility/http-utility/http-utility.service';
import { shareReplay } from 'rxjs/operators';
import { AcademicCalendarOrTerm } from '../../models/application/session-info.interface';

@Injectable({ providedIn: 'root' })
export class ApplicationGradesService {
	private readonly relativeUrl = 'grades/';
	private readonly gradeCacheMap: Map<boolean, Observable<Array<Grade>>> =
		new Map<boolean, Observable<Array<Grade>>>();

	constructor(private readonly http: HttpClient) {}

	getGrades(activeOnly = true): Observable<Array<Grade>> {
		const queryParams: HttpParamObject = HttpUtilityService.toPlainHttpParams({
			activeOnly
		});
		if (!this.gradeCacheMap.get(activeOnly)) {
			this.gradeCacheMap.set(
				activeOnly,
				this.requestGrades(queryParams).pipe(shareReplay(1))
			);
		}

		return this.gradeCacheMap.get(activeOnly);
	}

	getAcademicCalendars(): Observable<Array<AcademicCalendarOrTerm>> {
		return this.http.get<Array<AcademicCalendarOrTerm>>('/academic-calenders');
	}

	getAcademicTerms(): Observable<Array<AcademicCalendarOrTerm>> {
		return this.http.get<Array<AcademicCalendarOrTerm>>('/academic-terms');
	}

	private requestGrades(
		queryParams: HttpParamObject
	): Observable<Array<Grade>> {
		return this.http.get<Array<Grade>>(`${this.relativeUrl}`, queryParams);
	}
}
